import { render, staticRenderFns } from "./AiReviewPopup.vue?vue&type=template&id=2d461968&scoped=true&"
import script from "./AiReviewPopup.vue?vue&type=script&lang=js&"
export * from "./AiReviewPopup.vue?vue&type=script&lang=js&"
import style0 from "./AiReviewPopup.vue?vue&type=style&index=0&id=2d461968&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d461968",
  null
  
)

export default component.exports